// extracted by mini-css-extract-plugin
module.exports = {"social_links":"social_links_social_links__QaCZo"};